export const role = {
  unauthorized: () => 'unauthorized',
  logged: () => 'ROLE_LOGGED',
  user: () => 'ROLE_USER',
  root: () => 'ROLE_ROOT',
  admin: () => 'ROLE_ADMIN',
  nova: () => 'ROLE_NOVA',
  productOwner: () => 'ROLE_PRODUCT_OWNER',
  gateway: () => 'ROLE_GATEWAY', // временная роль для доступа к редактированию гейтвеев
  kpi: () => 'ROLE_KPI', // временная роль для доступов к странице KPI
  budget: () => 'ROLE_BUDGET', // роль для доступа к разделу Бюджетирование
  head: {
    ceo: () => 'ROLE_CEO',
    cfo: () => 'ROLE_CFO',
    cto: () => 'ROLE_CTO',
    cmo: () => 'ROLE_CMO',
    headOfSupport: () => 'ROLE_HEAD_OF_SUPPORT',
    headOfPartnerships: () => 'ROLE_HEAD_OF_PARTNERSHIPS',
  },
  clientSupport: {
    supportAgent: () => 'ROLE_SUPPORT_AGENT',
    supportManager: () => 'ROLE_SUPPORT_MANAGER',
    seniorSupport: () => 'ROLE_SENIOR_SUPPORT',
  },
  partnership: {
    seniorPartnerManager: () => 'ROLE_SENIOR_PARTNER_MANAGER',
    juniorPartnerManager: () => 'ROLE_JUNIOR_PARTNER_MANAGER',
  },
  verificatorManager: {
    verificator: () => `ROLE_VERIFICATOR`,
    verificatorAgent: () => `ROLE_VERIFICATOR_AGENT`,
    seniorVerificator: () => `ROLE_SENIOR_VERIFICATION_MANAGER`,
  },
  finances: {
    financeManager: () => `ROLE_FINANCE_MANAGER`,
    seniorFinanceManager: () => `ROLE_SENIOR_FINANCE_MANAGER`,
    leadFinanceManager: () => `ROLE_LEAD_FINANCE_MANAGER`,
  },
  finSystem: {
    finPO: () => `ROLE_FINSYSTEM_PO`,
    recalc: () => `ROLE_RECALC`,
  },
  dealer: {
    dealer: () => `ROLE_DEALER`,
  },
  it: {
    crmDeveloper: () => rolesObj.crmDeveloper,
    bca: () => rolesObj.bca,
    tester: () => rolesObj.tester,
  },
}

export const rolesObj = {
  // System roles
  unauthorized: 'unauthorized',
  logged: 'ROLE_LOGGED',
  user: 'ROLE_USER',
  root: 'ROLE_ROOT',
  admin: 'ROLE_ADMIN',
  gateway: 'ROLE_GATEWAY', // временная роль для вывода раздела гейтвеев
  budget: 'ROLE_BUDGET', // роль для просмотра раздела Бюджетирование

  // Chef roles
  ceo: 'ROLE_CEO',
  cfo: 'ROLE_CFO',
  cto: 'ROLE_CTO',
  cmo: 'ROLE_CMO',

  // Head of departments
  headOfSupport: 'ROLE_HEAD_OF_SUPPORT',
  headOfPartnerships: 'ROLE_HEAD_OF_PARTNERSHIPS',

  // Client support
  supportManager: 'ROLE_SUPPORT_MANAGER',
  supportAgent: 'ROLE_SUPPORT_AGENT',
  verificatorAgent: `ROLE_VERIFICATOR_AGENT`,

  // Finances
  financeManager: `ROLE_FINANCE_MANAGER`,
  seniorFinanceManager: `ROLE_SENIOR_FINANCE_MANAGER`,
  leadFinanceManager: `ROLE_LEAD_FINANCE_MANAGER`,

  // Dealers
  dealer: `ROLE_DEALER`,

  // IT
  administration: 'ROLE_ADMINISTRATION',
  techSupport: 'ROLE_TECH_SUPPORT',
  seniorTechSupport: 'ROLE_SENIOR_TECH_SUPPORT',
  bsa: 'ROLE_BSA',

  seniorPartnerManager: 'ROLE_SENIOR_PARTNER_MANAGER',
  juniorPartnerManager: 'ROLE_JUNIOR_PARTNER_MANAGER',
  tester: 'ROLE_TESTER',
  crmDeveloper: 'ROLE_CRM_DEVELOPER',
  bca: 'ROLE_BCA',
  giftshopPO: 'ROLE_GIFTSHOP_PO',
  giftshopManager: 'ROLE_GIFTSHOP_MANAGER',
  promoPO: 'ROLE_PROMO_PO',
  billingManager: 'ROLE_BILLING_MANAGER',
  copytradePO: 'ROLE_COPYTRADE_PO',
  supportAgentID: 'ROLE_SUPPORT_AGENT_ID',
  verificationAgent: 'ROLE_VERIFICATOR_AGENT',
  contestManager: 'ROLE_CONTEST_MANAGER',
  po: 'ROLE_PO',
  fpo: 'ROLE_FPO',

  // PO
  finSystemPO: 'ROLE_FINSYSTEM_PO',
  novaPO: 'ROLE_NOVA_PO',
  productOwner: 'ROLE_PRODUCT_OWNER',

  // Marketing
  pr: 'ROLE_PR',

  seniorSupportManager: 'ROLE_SENIOR_SUPPORT_MANAGER',
  seniorSupport: 'ROLE_SENIOR_SUPPORT',

  verificator: `ROLE_VERIFICATOR`,
  seniorVerificator: `ROLE_SENIOR_VERIFICATION_MANAGER`,

  pspo: 'ROLE_PSPO',
}
